import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import TableCustomKeysNoPagination from '@src/Pages/Private/Cliente/Admin/CorrespondenciaDevolvida/TableCustomKeysNoPagination';
import { TitlePage } from '@src/@styles/styles.global';

import InvisibleContent from '@src/components/Shared/InvisibleContent';

import Intencoes from '@src/Pages/Private/shared/SolicitacaoAtendimento/CreateHorarios/Intencoes';
import IntencaoMissa from '@src/Pages/Private/shared/SolicitacaoAtendimento/CreateHorarios/IntencaoMissa';
import ProgramaTV from '@src/Pages/Private/shared/SolicitacaoAtendimento/CreateHorarios/ProgramaTV';



const SolicitacaoAtendimento: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState('');

  const [openProgramaTV, setOpenProgramaTV] = useState(false);
  const [openIntencaoMissa, setOpenIntencaoMissa] = useState(false);
  const [openIntencoes, setOpenIntencoes] = useState(false);



  useEffect(() => {
    window.document.title = 'CRM - Solicitações atendimento';
  }, []);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Solicitações atendimento</TitlePage>
      </Grid>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        {/*<Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            //onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Intencao' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao'), setOpenProgramaTV(true), setOpenIntencaoMissa(false))}
          >
            Intenção
          </ButtonComponent>
        </Grid>*/}

<Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Intencoes' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencoes'), setOpenIntencoes(true), setOpenIntencaoMissa(false), setOpenProgramaTV(false))}
          >
            Intenções
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Intencao missa' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Intencao missa'), setOpenIntencaoMissa(true), setOpenIntencoes(false), setOpenProgramaTV(false))}
          >
            Horário de missa
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Programa TV' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Programa TV'), setOpenIntencaoMissa(false), setOpenIntencoes(false), setOpenProgramaTV(true))}
          >
            Programa
          </ButtonComponent>
        </Grid>



        <InvisibleContent visible={openIntencoes === true}>
        <Intencoes />
        </InvisibleContent>

        <InvisibleContent visible={openIntencaoMissa === true}>
        <IntencaoMissa />
        </InvisibleContent>

        <InvisibleContent visible={openProgramaTV === true}>
        <ProgramaTV />
        </InvisibleContent>

      </Grid>

    </Grid>
  );
};

export default SolicitacaoAtendimento;
